import {email, helpers, requiredIf} from "@vuelidate/validators";

export class ExternalAppealProviderModel {
    constructor(data = {}) {
        this.providerId = data.providerId ?? null;
        this.appealId = data.appealId ?? null;
        this.name = data.name ?? null;
        this.street = data.street ?? null;
        this.city = data.city ?? null;
        this.state = data.state ?? null;
        this.zipCode = data.zipCode ?? null;
        this.representative = data.representative ?? null;
        this.phoneNumber = data.phoneNumber ?? null;
        this.email = data.email ?? null;
        this.createdAt = data.createdAt ?? null;
        this.updatedAt = data.updatedAt ?? null;
    }

    isEmpty() {
        return !this.name &&
            !this.street &&
            !this.city &&
            !this.state &&
            !this.zipCode &&
            !this.phoneNumber &&
            !this.email &&
            !this.representative;
    }

    toRequestPayload() {
        return {
            providerId: this.providerId,
            appealId: this.appealId,
            name: this.name,
            street: this.street,
            city: this.city,
            state: this.state,
            zipCode: this.zipCode,
            representative: this.representative,
            phoneNumber: this.phoneNumber,
            email: this.email,
            createdAt: this.createdAt,
            updatedAt: this.updatedAt
        };
    }
}
